import React, { useState, useEffect } from "react";
import {
  X,
  Calendar,
  BrainCircuit,
  Star,
  FileText,
  ArrowRightCircle,
  Circle,
  CheckCircle2,
  Link as LinkIcon,
  Download,
  ChevronDown,
  AlertTriangle,
  Lightbulb,
  Target,
  LayoutTemplate,
  ArrowRight,
  User,
  Layers,
  CheckSquare,
} from "lucide-react";
import { palette, styles, useMediaQuery } from "../theme";
import { MEETING_DATA, TRANSCRIPT_TEXT } from "../data/weeksData";

// ==========================================
// 1. VISUALIZATION ENGINE (Dark Mode Graphics)
// ==========================================

// 1.1 Curriculum Map (Role x Time)
const VisualCurriculumMap = () => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "120px 1fr 1fr 1fr",
      gap: "12px",
      width: "100%",
    }}
  >
    <div
      style={{
        fontSize: "10px",
        color: "#64748B",
        fontWeight: 700,
        textTransform: "uppercase",
        paddingBottom: 8,
        borderBottom: "1px solid #334155",
      }}
    >
      Role
    </div>
    <div
      style={{
        fontSize: "10px",
        color: "#94A3B8",
        fontWeight: 700,
        textTransform: "uppercase",
        paddingBottom: 8,
        borderBottom: "1px solid #334155",
      }}
    >
      Wk 1: Basics
    </div>
    <div
      style={{
        fontSize: "10px",
        color: "#94A3B8",
        fontWeight: 700,
        textTransform: "uppercase",
        paddingBottom: 8,
        borderBottom: "1px solid #334155",
      }}
    >
      Mo 1: Deep Dive
    </div>
    <div
      style={{
        fontSize: "10px",
        color: "#C5A059",
        fontWeight: 700,
        textTransform: "uppercase",
        paddingBottom: 8,
        borderBottom: "1px solid #C5A059",
      }}
    >
      Continuous
    </div>

    <div
      style={{
        fontSize: "12px",
        fontWeight: 600,
        color: "#E2E8F0",
        alignSelf: "center",
      }}
    >
      Account Exec
    </div>
    <div
      style={{
        background: "#1E293B",
        border: "1px solid #334155",
        borderRadius: 6,
        padding: "8px",
        fontSize: "11px",
        color: "#94A3B8",
      }}
    >
      <div
        style={{
          width: 20,
          height: 4,
          background: "#3B82F6",
          borderRadius: 2,
          marginBottom: 4,
        }}
      />
      Basics
    </div>
    <div
      style={{
        background: "#1E293B",
        border: "1px solid #334155",
        borderRadius: 6,
        padding: "8px",
        fontSize: "11px",
        color: "#E2E8F0",
      }}
    >
      <div
        style={{
          width: 20,
          height: 4,
          background: "#3B82F6",
          borderRadius: 2,
          marginBottom: 4,
        }}
      />
      Buyer Personas
    </div>
    <div
      style={{
        background: "rgba(197, 160, 89, 0.1)",
        border: "1px solid #C5A059",
        borderRadius: 6,
        padding: "8px",
        fontSize: "11px",
        color: "#C5A059",
      }}
    >
      <div
        style={{
          width: 20,
          height: 4,
          background: "#C5A059",
          borderRadius: 2,
          marginBottom: 4,
        }}
      />
      Advanced Pitch
    </div>

    <div
      style={{
        fontSize: "12px",
        fontWeight: 600,
        color: "#E2E8F0",
        alignSelf: "center",
      }}
    >
      Prod Specialist
    </div>
    <div
      style={{
        background: "#1E293B",
        border: "1px solid #334155",
        borderRadius: 6,
        padding: "8px",
        fontSize: "11px",
        color: "#94A3B8",
      }}
    >
      <div
        style={{
          width: 20,
          height: 4,
          background: "#10B981",
          borderRadius: 2,
          marginBottom: 4,
        }}
      />
      Deep Dive
    </div>
    <div
      style={{
        background: "#1E293B",
        border: "1px solid #334155",
        borderRadius: 6,
        padding: "8px",
        fontSize: "11px",
        color: "#E2E8F0",
      }}
    >
      <div
        style={{
          width: 20,
          height: 4,
          background: "#10B981",
          borderRadius: 2,
          marginBottom: 4,
        }}
      />
      Tech Specs
    </div>
    <div
      style={{
        background: "rgba(197, 160, 89, 0.1)",
        border: "1px solid #C5A059",
        borderRadius: 6,
        padding: "8px",
        fontSize: "11px",
        color: "#C5A059",
      }}
    >
      <div
        style={{
          width: 20,
          height: 4,
          background: "#C5A059",
          borderRadius: 2,
          marginBottom: 4,
        }}
      />
      Certification
    </div>
  </div>
);

// 1.2 Coverage Matrix
const VisualCoverageMatrix = () => (
  <div
    style={{
      width: "100%",
      background: "#0F1E36",
      border: "1px solid #334155",
      borderRadius: 8,
      overflow: "hidden",
    }}
  >
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        background: "#1E293B",
        borderBottom: "1px solid #334155",
      }}
    >
      <div
        style={{
          padding: "12px",
          fontSize: "10px",
          fontWeight: 700,
          color: "#64748B",
        }}
      >
        ROLE
      </div>
      <div
        style={{
          padding: "12px",
          fontSize: "10px",
          fontWeight: 700,
          color: "#C5A059",
        }}
      >
        CORE
      </div>
      <div
        style={{
          padding: "12px",
          fontSize: "10px",
          fontWeight: 700,
          color: "#94A3B8",
        }}
      >
        ADD-ONS
      </div>
      <div
        style={{
          padding: "12px",
          fontSize: "10px",
          fontWeight: 700,
          color: "#94A3B8",
        }}
      >
        LEGACY
      </div>
    </div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        borderBottom: "1px solid #334155",
      }}
    >
      <div
        style={{
          padding: "12px",
          fontSize: "12px",
          color: "#E2E8F0",
          fontWeight: 600,
        }}
      >
        AE
      </div>
      <div style={{ padding: "12px" }}>
        <span
          style={{
            background: "rgba(16, 185, 129, 0.2)",
            color: "#34D399",
            fontSize: "10px",
            padding: "2px 6px",
            borderRadius: 4,
            fontWeight: 700,
          }}
        >
          REQUIRED
        </span>
      </div>
      <div style={{ padding: "12px" }}>
        <span
          style={{
            background: "rgba(59, 130, 246, 0.2)",
            color: "#60A5FA",
            fontSize: "10px",
            padding: "2px 6px",
            borderRadius: 4,
          }}
        >
          OPTIONAL
        </span>
      </div>
      <div style={{ padding: "12px" }}>
        <span
          style={{
            background: "#334155",
            color: "#94A3B8",
            fontSize: "10px",
            padding: "2px 6px",
            borderRadius: 4,
          }}
        >
          AWARENESS
        </span>
      </div>
    </div>
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
      <div
        style={{
          padding: "12px",
          fontSize: "12px",
          color: "#E2E8F0",
          fontWeight: 600,
        }}
      >
        Prod Spec
      </div>
      <div style={{ padding: "12px" }}>
        <span
          style={{
            background: "rgba(197, 160, 89, 0.2)",
            color: "#FCD34D",
            fontSize: "10px",
            padding: "2px 6px",
            borderRadius: 4,
            fontWeight: 700,
          }}
        >
          EXPERT
        </span>
      </div>
      <div style={{ padding: "12px" }}>
        <span
          style={{
            background: "rgba(16, 185, 129, 0.2)",
            color: "#34D399",
            fontSize: "10px",
            padding: "2px 6px",
            borderRadius: 4,
          }}
        >
          REQUIRED
        </span>
      </div>
      <div style={{ padding: "12px" }}>
        <span
          style={{
            background: "rgba(59, 130, 246, 0.2)",
            color: "#60A5FA",
            fontSize: "10px",
            padding: "2px 6px",
            borderRadius: 4,
          }}
        >
          OPTIONAL
        </span>
      </div>
    </div>
  </div>
);

// 1.3 Curriculum Index
const VisualCurriculumIndex = () => (
  <div
    style={{
      width: "100%",
      background: "#0F1E36",
      borderRadius: 8,
      overflow: "hidden",
      border: "1px solid #334155",
    }}
  >
    <div
      style={{
        padding: "16px",
        borderBottom: "1px solid #334155",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ fontSize: "14px", fontWeight: 700, color: "#FFFFFF" }}>
        Product Ed <span style={{ color: "#C5A059" }}>Home</span>
      </div>
      <div
        style={{
          width: "120px",
          height: "8px",
          background: "#334155",
          borderRadius: 4,
        }}
      ></div>
    </div>
    <div style={{ padding: "24px", display: "flex", gap: "16px" }}>
      <div
        style={{
          flex: 1,
          background: "#1E293B",
          padding: "20px",
          borderRadius: 8,
          border: "1px solid #334155",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            background: "#3B82F6",
            borderRadius: "50%",
            margin: "0 auto 12px auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <User size={16} color="#FFF" />
        </div>
        <div
          style={{
            fontSize: "13px",
            fontWeight: 600,
            color: "#E2E8F0",
            marginBottom: 4,
          }}
        >
          I am an AE
        </div>
        <div style={{ fontSize: "10px", color: "#94A3B8" }}>
          Click here for sales basics
        </div>
      </div>
      <div
        style={{
          flex: 1,
          background: "#1E293B",
          padding: "20px",
          borderRadius: 8,
          border: "1px solid #334155",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            background: "#10B981",
            borderRadius: "50%",
            margin: "0 auto 12px auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Layers size={16} color="#FFF" />
        </div>
        <div
          style={{
            fontSize: "13px",
            fontWeight: 600,
            color: "#E2E8F0",
            marginBottom: 4,
          }}
        >
          I am a Specialist
        </div>
        <div style={{ fontSize: "10px", color: "#94A3B8" }}>
          Click here for deep dives
        </div>
      </div>
    </div>
  </div>
);

// 2.1 Role Charter
const VisualRoleCharter = () => (
  <div
    style={{
      width: "100%",
      background: "#1E293B",
      borderRadius: 8,
      border: "1px solid #3B82F6",
      padding: "20px",
    }}
  >
    <div
      style={{
        fontSize: "10px",
        color: "#3B82F6",
        fontWeight: 700,
        textTransform: "uppercase",
        marginBottom: 8,
        letterSpacing: "1px",
      }}
    >
      ROLE CHARTER
    </div>
    <div
      style={{
        fontSize: "18px",
        fontWeight: 700,
        color: "#FFFFFF",
        marginBottom: 16,
      }}
    >
      Account Executive
    </div>
    <div style={{ display: "grid", gap: "12px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div
          style={{
            padding: 6,
            background: "rgba(197, 160, 89, 0.2)",
            borderRadius: 4,
          }}
        >
          <Star size={14} color="#C5A059" />
        </div>
        <div>
          <div style={{ fontSize: "12px", fontWeight: 700, color: "#E2E8F0" }}>
            Pitch: EXPERT
          </div>
          <div style={{ fontSize: "11px", color: "#94A3B8" }}>
            Must pass video certification
          </div>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div
          style={{
            padding: 6,
            background: "rgba(59, 130, 246, 0.2)",
            borderRadius: 4,
          }}
        >
          <BrainCircuit size={14} color="#60A5FA" />
        </div>
        <div>
          <div style={{ fontSize: "12px", fontWeight: 700, color: "#E2E8F0" }}>
            Technical: AWARENESS
          </div>
          <div style={{ fontSize: "11px", color: "#94A3B8" }}>
            Know who to ask, do not demo API
          </div>
        </div>
      </div>
    </div>
  </div>
);

// 2.2 Readiness Checklist
const VisualReadinessChecklist = () => (
  <div
    style={{
      width: "100%",
      background: "#1E293B",
      borderRadius: 8,
      border: "1px solid #334155",
      padding: "20px",
    }}
  >
    <div
      style={{
        fontSize: "14px",
        fontWeight: 600,
        color: "#FFFFFF",
        marginBottom: 16,
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <CheckSquare size={16} color="#10B981" /> AE Readiness Checklist
    </div>
    <div style={{ display: "grid", gap: "8px" }}>
      {[
        "Can identify the 3 target buyer personas",
        "Can articulate 'Speed to Market' differentiator",
        "Knows where to find pricing calculator",
        "Has completed 'Competitor Battlecard' review",
      ].map((item, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            padding: "8px",
            background: "#0F1E36",
            borderRadius: 4,
          }}
        >
          <div
            style={{
              width: 16,
              height: 16,
              borderRadius: 4,
              border: "1px solid #10B981",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: 8,
                height: 8,
                background: "#10B981",
                borderRadius: 2,
              }}
            />
          </div>
          <div style={{ fontSize: "12px", color: "#CBD5E1" }}>{item}</div>
        </div>
      ))}
    </div>
  </div>
);

// 3.1 Ownership Matrix
const VisualOwnershipMatrix = () => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      gap: "1px",
      background: "#334155",
      border: "1px solid #334155",
      borderRadius: 8,
      overflow: "hidden",
    }}
  >
    <div
      style={{
        background: "#0F1E36",
        padding: "12px",
        fontSize: "10px",
        color: "#94A3B8",
        fontWeight: 700,
      }}
    >
      TOPIC
    </div>
    <div
      style={{
        background: "#0F1E36",
        padding: "12px",
        fontSize: "10px",
        color: "#C5A059",
        fontWeight: 700,
      }}
    >
      PRODUCT ED
    </div>
    <div
      style={{
        background: "#0F1E36",
        padding: "12px",
        fontSize: "10px",
        color: "#3B82F6",
        fontWeight: 700,
      }}
    >
      SALES SKILLS
    </div>

    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#E2E8F0",
      }}
    >
      Value Prop
    </div>
    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#C5A059",
        fontWeight: 700,
      }}
    >
      OWNER
    </div>
    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#94A3B8",
      }}
    >
      Consulted
    </div>

    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#E2E8F0",
      }}
    >
      Negotiation
    </div>
    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#94A3B8",
      }}
    >
      ---
    </div>
    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#3B82F6",
        fontWeight: 700,
      }}
    >
      OWNER
    </div>

    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#E2E8F0",
      }}
    >
      Objections
    </div>
    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#E2E8F0",
      }}
    >
      Content Source
    </div>
    <div
      style={{
        background: "#1E293B",
        padding: "12px",
        fontSize: "12px",
        color: "#E2E8F0",
      }}
    >
      Delivery Method
    </div>
  </div>
);

// 3.2 Learning Flow
const VisualLearningFlow = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      padding: "20px",
      background: "#0F1E36",
      borderRadius: 8,
      border: "1px solid #334155",
    }}
  >
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          padding: "10px",
          background: "#1E293B",
          border: "1px solid #C5A059",
          borderRadius: 6,
          fontSize: "11px",
          color: "#E2E8F0",
          fontWeight: 600,
          marginBottom: 6,
        }}
      >
        Product Ed
      </div>
      <div style={{ fontSize: "10px", color: "#94A3B8" }}>"What is it?"</div>
    </div>
    <ArrowRight size={16} color="#64748B" />
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          padding: "10px",
          background: "#1E293B",
          border: "1px solid #10B981",
          borderRadius: 6,
          fontSize: "11px",
          color: "#E2E8F0",
          fontWeight: 600,
          marginBottom: 6,
        }}
      >
        Context
      </div>
      <div style={{ fontSize: "10px", color: "#94A3B8" }}>"Who buys it?"</div>
    </div>
    <ArrowRight size={16} color="#64748B" />
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          padding: "10px",
          background: "#1E293B",
          border: "1px solid #3B82F6",
          borderRadius: 6,
          fontSize: "11px",
          color: "#E2E8F0",
          fontWeight: 600,
          marginBottom: 6,
        }}
      >
        Sales Skills
      </div>
      <div style={{ fontSize: "10px", color: "#94A3B8" }}>"How to close?"</div>
    </div>
  </div>
);

// 4.1 Trevi Insertion
const VisualTreviInsertion = () => (
  <div
    style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%" }}
  >
    <div
      style={{
        padding: "12px",
        borderRadius: 6,
        border: "1px solid #334155",
        background: "#1E293B",
        color: "#64748B",
        fontSize: "13px",
      }}
    >
      Module 3: Core Platform
    </div>
    <div
      style={{
        padding: "12px",
        borderRadius: 6,
        border: "1px solid #334155",
        background: "#1E293B",
        color: "#64748B",
        fontSize: "13px",
      }}
    >
      Module 4: Security Add-ons
    </div>

    {/* THE INSERTION */}
    <div
      style={{
        padding: "16px",
        borderRadius: 8,
        border: "1px solid #C5A059",
        background:
          "linear-gradient(90deg, rgba(197, 160, 89, 0.15) 0%, rgba(15, 30, 54, 0) 100%)",
        color: "#C5A059",
        fontSize: "14px",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <div
        style={{
          background: "#C5A059",
          color: "#0F1E36",
          fontSize: "10px",
          fontWeight: 800,
          padding: "2px 6px",
          borderRadius: 4,
        }}
      >
        NEW
      </div>
      Trevi Launch Module (Required)
    </div>

    <div
      style={{
        padding: "12px",
        borderRadius: 6,
        border: "1px solid #334155",
        background: "#1E293B",
        color: "#64748B",
        fontSize: "13px",
      }}
    >
      Module 5: Legacy Systems
    </div>
  </div>
);

// 4.2 Trevi Overlay
const VisualTreviOverlay = () => (
  <div
    style={{
      width: "100%",
      background: "#1E293B",
      padding: "20px",
      borderRadius: 8,
      border: "1px solid #334155",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 12,
      }}
    >
      <div style={{ fontSize: "12px", color: "#E2E8F0", fontWeight: 600 }}>
        Pitch Deck
      </div>
      <div style={{ fontSize: "10px", color: "#94A3B8" }}>80% Reused</div>
    </div>
    <div
      style={{
        height: 8,
        width: "100%",
        background: "#334155",
        borderRadius: 4,
        overflow: "hidden",
        marginBottom: 20,
      }}
    >
      <div
        style={{
          width: "80%",
          height: "100%",
          background: "#64748B",
          float: "left",
        }}
      />
      <div
        style={{
          width: "20%",
          height: "100%",
          background: "#10B981",
          float: "left",
        }}
      />
    </div>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 12,
      }}
    >
      <div style={{ fontSize: "12px", color: "#E2E8F0", fontWeight: 600 }}>
        One Pager
      </div>
      <div style={{ fontSize: "10px", color: "#10B981" }}>100% NEW</div>
    </div>
    <div
      style={{
        height: 8,
        width: "100%",
        background: "#334155",
        borderRadius: 4,
        overflow: "hidden",
        marginBottom: 20,
      }}
    >
      <div style={{ width: "100%", height: "100%", background: "#10B981" }} />
    </div>

    <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: 2,
            background: "#64748B",
          }}
        />
        <div style={{ fontSize: "10px", color: "#94A3B8" }}>Existing</div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: 2,
            background: "#10B981",
          }}
        />
        <div style={{ fontSize: "10px", color: "#94A3B8" }}>New / Trevi</div>
      </div>
    </div>
  </div>
);

const DefaultVisual = ({ text }) => (
  <div
    style={{
      background: "#1E293B",
      borderRadius: 8,
      padding: "24px",
      color: "#E2E8F0",
      fontFamily: "monospace",
      fontSize: "12px",
      whiteSpace: "pre-wrap",
      border: "1px solid #334155",
    }}
  >
    <div
      style={{
        fontSize: "10px",
        textTransform: "uppercase",
        color: "#64748B",
        marginBottom: "10px",
        letterSpacing: "1px",
      }}
    >
      Wireframe / Visual Structure
    </div>
    {text}
  </div>
);

// --- 2. TRANSCRIPT COMPONENT ---
const TranscriptModal = ({ onClose }) => (
  <div style={{ ...styles.modalOverlay, zIndex: 1200 }} onClick={onClose}>
    <div
      style={{ ...styles.modalContent, maxWidth: "600px", height: "80vh" }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{
          padding: "20px",
          borderBottom: `1px solid ${palette.line}`,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3 style={{ margin: 0, color: palette.text }}>Full Transcript</h3>
        <button
          onClick={onClose}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            padding: "8px",
          }}
        >
          <X size={20} />
        </button>
      </div>
      <div
        style={{
          padding: "24px",
          overflowY: "auto",
          fontFamily: "monospace",
          fontSize: "13px",
          lineHeight: "1.6",
          color: palette.text,
        }}
      >
        {TRANSCRIPT_TEXT.split("\n").map((line, i) => (
          <div key={i} style={{ marginBottom: "12px" }}>
            {line}
          </div>
        ))}
      </div>
    </div>
  </div>
);

// --- 3. UPDATED SOLUTION PREVIEW MODAL (DARK MODE) ---
const SolutionPreviewModal = ({ example, onClose }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  // LOGIC TO CHOOSE THE RIGHT VISUAL
  const renderVisual = () => {
    const t = example.title || "";

    // 1. Curriculum
    if (t.includes("Role x Time")) return <VisualCurriculumMap />;
    if (t.includes("Coverage Matrix")) return <VisualCoverageMatrix />;
    if (t.includes("Index Page")) return <VisualCurriculumIndex />;

    // 2. Expectations
    if (t.includes("Charter")) return <VisualRoleCharter />;
    if (t.includes("Checklist")) return <VisualReadinessChecklist />;

    // 3. Boundaries
    if (t.includes("Boundary")) return <VisualOwnershipMatrix />;
    if (t.includes("Flow")) return <VisualLearningFlow />;

    // 4. Launches
    if (t.includes("Trevi Launch")) return <VisualTreviInsertion />;
    if (t.includes("Core Overlay")) return <VisualTreviOverlay />;

    return <DefaultVisual text={example.mockup || "No visual available"} />;
  };

  return (
    <div style={{ ...styles.modalOverlay, zIndex: 1300 }} onClick={onClose}>
      <div
        style={{
          ...styles.modalContent,
          maxWidth: "800px",
          maxHeight: "90vh",
          overflow: "hidden",
          backgroundColor: "#0F1E36",
          color: "#FFFFFF",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div
          style={{
            padding: "24px",
            borderBottom: `1px solid rgba(255,255,255,0.1)`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexShrink: 0,
          }}
        >
          <div>
            <div
              style={{
                fontSize: "11px",
                fontWeight: 700,
                color: palette.gold,
                textTransform: "uppercase",
                marginBottom: "8px",
                letterSpacing: "0.05em",
              }}
            >
              Solution Preview
            </div>
            <h3
              style={{
                margin: 0,
                fontSize: isMobile ? "18px" : "24px",
                fontWeight: 700,
                color: "#FFFFFF",
                fontFamily: "serif",
              }}
            >
              {example.title}
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            <X size={24} color="rgba(255,255,255,0.5)" />
          </button>
        </div>

        {/* SCROLLABLE CONTENT */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            overflowY: "auto",
          }}
        >
          {/* VISUALIZATION AREA (The "Dark Mode" container) */}
          <div
            style={{
              background: "linear-gradient(180deg, #0F1E36 0%, #0B1628 100%)",
              padding: isMobile ? "24px" : "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "300px",
            }}
          >
            <div style={{ width: "100%", maxWidth: "600px" }}>
              {renderVisual()}
            </div>
          </div>

          {/* FOOTER DETAILS */}
          <div
            style={{
              padding: "24px",
              backgroundColor: "#FFFFFF",
              color: palette.text,
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: "24px",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 700,
                  color: palette.textSoft,
                  marginBottom: "8px",
                  textTransform: "uppercase",
                }}
              >
                Why this version?
              </div>
              <p style={{ fontSize: "14px", lineHeight: "1.5", margin: 0 }}>
                {example.why}
              </p>
            </div>
            <div>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 700,
                  color: palette.textSoft,
                  marginBottom: "8px",
                  textTransform: "uppercase",
                }}
              >
                When to use it
              </div>
              <p style={{ fontSize: "14px", lineHeight: "1.5", margin: 0 }}>
                {example.when}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- 4. INSIGHT CARD COMPONENT ---
const InsightCard = ({ insight, isOpen, onToggle }) => {
  return (
    <div
      style={{
        backgroundColor: isOpen ? "#FFFFFF" : palette.goldLight,
        borderRadius: "8px",
        border: isOpen ? `1px solid ${palette.gold}` : `1px solid transparent`,
        boxShadow: isOpen ? "0 4px 12px rgba(197, 160, 89, 0.15)" : "none",
        overflow: "hidden",
        transition: "all 0.2s ease",
      }}
    >
      <button
        onClick={() => onToggle(insight.id)}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
          padding: "16px",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        <div style={{ marginTop: 4 }}>
          <Star
            size={16}
            fill={isOpen ? palette.gold : "transparent"}
            color={palette.gold}
          />
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: "14px",
              fontWeight: 700,
              color: palette.bgSidebar,
              marginBottom: "4px",
            }}
          >
            {insight.label}
          </div>
          {!isOpen && (
            <div
              style={{ fontSize: "13px", color: palette.text, lineHeight: 1.4 }}
            >
              {insight.summary}
            </div>
          )}
        </div>
        <ChevronDown
          size={18}
          color={palette.textSoft}
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        />
      </button>

      {isOpen && (
        <div
          style={{
            padding: "0 16px 20px 44px",
            animation: "fadeIn 0.3s ease-in-out",
          }}
        >
          <div style={{ marginBottom: "20px" }}>
            {insight.expanded.paragraphs.map((p, i) => (
              <p
                key={i}
                style={{
                  fontSize: "14px",
                  lineHeight: "1.6",
                  color: palette.text,
                  marginTop: 0,
                  marginBottom: "12px",
                }}
              >
                {p}
              </p>
            ))}
          </div>

          <div
            style={{
              display: "grid",
              gap: "16px",
              borderTop: `1px solid ${palette.line}`,
              paddingTop: "16px",
            }}
          >
            {insight.expanded.bullets.whyItMatters && (
              <div>
                <div
                  style={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: palette.gold,
                    textTransform: "uppercase",
                    marginBottom: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Lightbulb size={12} /> Why it Matters
                </div>
                <ul
                  style={{
                    margin: 0,
                    paddingLeft: "16px",
                    fontSize: "13px",
                    color: palette.textSoft,
                  }}
                >
                  {insight.expanded.bullets.whyItMatters.map((item, i) => (
                    <li key={i} style={{ marginBottom: "4px" }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {insight.expanded.bullets.nextSteps && (
              <div
                style={{
                  backgroundColor: "#F8FAFC",
                  padding: "12px",
                  borderRadius: "6px",
                }}
              >
                <div
                  style={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: palette.bgSidebar,
                    textTransform: "uppercase",
                    marginBottom: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Target size={12} /> Recommended Actions
                </div>
                <ul
                  style={{
                    margin: 0,
                    paddingLeft: "16px",
                    fontSize: "13px",
                    color: palette.text,
                  }}
                >
                  {insight.expanded.bullets.nextSteps.map((item, i) => (
                    <li key={i} style={{ marginBottom: "4px" }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// --- 5. MAIN MODAL COMPONENT ---

const MeetingAnalysisModal = ({ onClose }) => {
  const [showTranscript, setShowTranscript] = useState(false);
  const [activeExample, setActiveExample] = useState(null);
  const [expandedId, setExpandedId] = useState(null);
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const insightId = params.get("insight");
    if (insightId) {
      setExpandedId(insightId);
    }
  }, []);

  const handleToggle = (id) => {
    const newId = expandedId === id ? null : id;
    setExpandedId(newId);
    const url = new URL(window.location);
    if (newId) url.searchParams.set("insight", newId);
    else url.searchParams.delete("insight");
    window.history.pushState({}, "", url);
  };

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div
        style={{
          ...styles.modalContent,
          height: isMobile ? "100%" : "auto",
          borderRadius: isMobile ? "0px" : "16px",
          maxHeight: isMobile ? "100%" : "90vh",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div
          style={{
            padding: isMobile ? "20px" : "32px",
            backgroundColor: palette.bgSidebar,
            color: "#FFF",
            display: "flex",
            justifyContent: "space-between",
            flexShrink: 0,
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginBottom: 8,
                opacity: 0.8,
              }}
            >
              <Calendar size={14} /> {MEETING_DATA.date}
            </div>
            <h2
              style={{
                fontSize: isMobile ? "20px" : "28px",
                fontWeight: 700,
                margin: 0,
                fontFamily: "serif",
              }}
            >
              {MEETING_DATA.title}
            </h2>
            <div style={{ display: "flex", gap: 12, marginTop: 16 }}>
              {MEETING_DATA.attendees.map((a) => (
                <span
                  key={a}
                  style={{
                    fontSize: "12px",
                    background: "rgba(255,255,255,0.1)",
                    padding: "4px 10px",
                    borderRadius: "4px",
                  }}
                >
                  {a}
                </span>
              ))}
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              color: "rgba(255,255,255,0.6)",
              cursor: "pointer",
              height: "fit-content",
              padding: "8px",
            }}
          >
            <X size={24} />
          </button>
        </div>

        {/* BODY */}
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: isMobile ? "column" : "row",
            overflow: "hidden",
          }}
        >
          {/* LEFT COL: INSIGHTS & SUMMARY */}
          <div
            style={{
              flex: 3,
              padding: isMobile ? "20px" : "32px",
              overflowY: "auto",
              borderRight: isMobile ? "none" : `1px solid ${palette.line}`,
              borderBottom: isMobile ? `1px solid ${palette.line}` : "none",
            }}
          >
            <div style={{ marginBottom: "32px" }}>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: palette.textSoft,
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  marginBottom: "12px",
                }}
              >
                Executive Summary
              </div>
              <p
                style={{
                  fontSize: "15px",
                  lineHeight: "1.6",
                  color: palette.text,
                }}
              >
                {MEETING_DATA.summary}
              </p>
            </div>

            <div style={{ marginBottom: "32px" }}>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: palette.gold,
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  marginBottom: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <BrainCircuit size={14} /> Strategic Decisions (Deep Dive)
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 12 }}
              >
                {MEETING_DATA.insights.map((insight) => (
                  <InsightCard
                    key={insight.id}
                    insight={insight}
                    isOpen={expandedId === insight.id}
                    onToggle={handleToggle}
                  />
                ))}
              </div>
            </div>

            <div
              onClick={() => setShowTranscript(true)}
              style={{
                padding: "16px",
                border: `1px dashed ${palette.line}`,
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: 12,
                cursor: "pointer",
                color: palette.textSoft,
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#F8FAFC")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              <FileText size={20} />
              <div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: palette.text,
                  }}
                >
                  Read Full Transcript
                </div>
                <div style={{ fontSize: "12px" }}>
                  Raw text generated from call recording
                </div>
              </div>
              <ArrowRightCircle size={16} style={{ marginLeft: "auto" }} />
            </div>
          </div>

          {/* RIGHT COL: ACTIONS & RESOURCES */}
          <div
            style={{
              flex: 2,
              padding: isMobile ? "20px" : "32px",
              backgroundColor: "#F8FAFC",
              overflowY: "auto",
              paddingBottom: isMobile ? "80px" : "32px",
            }}
          >
            {/* ACTION ITEMS with EXAMPLES */}
            <div style={{ marginBottom: "32px" }}>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: palette.textSoft,
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  marginBottom: "16px",
                }}
              >
                Action Items
              </div>

              <div style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: palette.bgSidebar,
                    marginBottom: "12px",
                  }}
                >
                  Assigned to You
                </div>
                {MEETING_DATA.actions.her.map((action, i) => (
                  <div
                    key={i}
                    style={{
                      marginBottom: "24px",
                      borderLeft: `3px solid ${palette.gold}`,
                      paddingLeft: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 10,
                        marginBottom: "8px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: palette.text,
                          lineHeight: 1.4,
                        }}
                      >
                        {action.text}
                      </span>
                    </div>

                    {/* EXAMPLE CHIPS */}
                    {action.examples && (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {action.examples.map((ex, j) => (
                          <button
                            key={j}
                            onClick={() => setActiveExample(ex)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "6px 10px",
                              backgroundColor: "#FFFFFF",
                              border: `1px solid ${palette.line}`,
                              borderRadius: "20px",
                              fontSize: "11px",
                              fontWeight: 600,
                              color: palette.navyLight,
                              cursor: "pointer",
                              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                              transition: "all 0.1s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.borderColor = palette.gold)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.borderColor = palette.line)
                            }
                          >
                            <LayoutTemplate size={12} /> {ex.tag}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: palette.textSoft,
                    marginBottom: "12px",
                  }}
                >
                  Waiting on Boss
                </div>
                {MEETING_DATA.actions.them.map((action, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 10,
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircle2
                      size={16}
                      color={
                        action.status === "done"
                          ? palette.success
                          : palette.textSoft
                      }
                      style={{ marginTop: 2, flexShrink: 0 }}
                    />
                    <span
                      style={{
                        fontSize: "13px",
                        color: palette.textSoft,
                        textDecoration:
                          action.status === "done" ? "line-through" : "none",
                      }}
                    >
                      {action.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* RESOURCES */}
            <div>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: palette.textSoft,
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  marginBottom: "16px",
                }}
              >
                New Resources
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {MEETING_DATA.resources.map((res, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      padding: "10px",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "6px",
                      border: `1px solid ${palette.line}`,
                      cursor: "pointer",
                    }}
                  >
                    {res.type === "link" ? (
                      <LinkIcon size={14} color={palette.navyLight} />
                    ) : (
                      <Download size={14} color={palette.navyLight} />
                    )}
                    <span
                      style={{
                        fontSize: "13px",
                        color: palette.navyLight,
                        fontWeight: 500,
                        flex: 1,
                      }}
                    >
                      {res.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MODALS */}
      {showTranscript && (
        <TranscriptModal onClose={() => setShowTranscript(false)} />
      )}
      {activeExample && (
        <SolutionPreviewModal
          example={activeExample}
          onClose={() => setActiveExample(null)}
        />
      )}
    </div>
  );
};

export default MeetingAnalysisModal;
